import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { useContext, useRef } from 'react';
export function useShouldRenderAdArea(adSafety, allowCollapse = false) {
    const hasBeenRendered = useRef(false);
    const { adsEnabled  } = useContext(SessionContext);
    const isNsfgFallback = useFlag('ads_dealer_nsfg');
    // Once rendered we always want to keep the area
    if (hasBeenRendered.current === true && !allowCollapse) {
        return true;
    }
    const shouldRender = isNsfgFallback ? adsEnabled : adsEnabled && adSafety !== 'off';
    if (shouldRender && hasBeenRendered.current === false) {
        hasBeenRendered.current = true;
    }
    return shouldRender;
}
